import { useAtom } from 'jotai';

import { useDeviceName } from 'lib/api/myRobot';
import { DEFAULT_ROTATION_AXIS_HEIGHT } from 'lib/constants/variables';

import { RobotRotationAxes, RobotSpeed, robotControlAtom } from './robot-control.atom';

/**
 * Todo - Refactor hook - either own hooks/atoms or with selectors for each part
 */
export const useRobotControlState = () => {
  const { deviceName } = useDeviceName();
  const [robotControlState, setRobotControlState] = useAtom(robotControlAtom(deviceName));

  const setRobotSpeed = (speed: RobotSpeed) => {
    setRobotControlState((prev) => ({ ...prev, speed }));
  };

  const toggleRotationAxesLock = () => {
    setRobotControlState((prev) => ({ ...prev, isRotationAxesLocked: !prev.isRotationAxesLocked }));
  };

  const setRobotRotationAxes = (rotationAxes: RobotRotationAxes) => {
    setRobotControlState((prev) => ({ ...prev, rotationAxes }));
  };

  const resetRobotRotationAxes = () => {
    setRobotRotationAxes({ roll: 0, pitch: 0, yaw: 0, height: DEFAULT_ROTATION_AXIS_HEIGHT });
  };

  return [
    robotControlState,
    {
      setRobotSpeed,
      setRobotControlState,
      setRobotRotationAxes,
      resetRobotRotationAxes,
      toggleRotationAxesLock,
    },
  ] as const;
};
